import { defineComponent as _defineComponent } from 'vue'
import { computed, useAttrs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CRList',
  props: {
    autoGrow: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    label: null,
    items: { default: () => [] },
    height: { default: 100 },
    selectedItem: { default: "" }
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
  (e: "select", item: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { autoGrow: boolean, disabled: boolean, label?: string, items: string[], height: number, selectedItem: string | null };





const selectItem = (item: string) => {
  if (props.disabled) return;
  emit("select", item);
};

const cssVars = computed(() => ({
  "--min-height": `${props.height}px`,
  "--max-height": props.autoGrow ? "none" : `${props.height}px`,
  "--overflowY": props.autoGrow ? "auto" : "scroll",
  "--overflowX": "hidden",
}));

const inputWrapperClass = computed(() => {
  let classStr = "cr-list__input-wrapper";
  if (props.disabled) classStr += " cr-list__input-wrapper__disabled";
  return classStr;
});

useAttrs();

return { __sfc: true,props, emit, selectItem, cssVars, inputWrapperClass }
}

})